import ActionType from '../../actions/ActionType'
import { combineReducers } from 'redux'
import fields from './fields'
import modal from './modal'
import groupSelect from './groupSelect'

const entitiesReducer = (state = [], action) => {
	switch (action.type) {
		case ActionType.SmartNotes.GET_ENTITIES_SUCCESS:
			return action.payload.Entities
		case '@@router/LOCATION_CHANGE':
			return []
		default:
			return state
	}
}

const addDetailsModalOpen = (state = false, action) => {
	switch (action.type) {
		case ActionType.Contacts.OPEN_ADD_DETAILS_MODAL:
			return true
		case ActionType.Contacts.CLOSE_ADD_DETAILS_MODAL:
			return false
		case ActionType.Contacts.TOGGLE_ADD_DETAILS_MODAL:
			return !state
		default:
			return state
	}
}

const smartNotes = (state = { focused: false }, action) => {
	switch (action.type) {
		case ActionType.SmartNotes.FOCUS:
			return {
				...state,
				focused: true,
			}
		case ActionType.SmartNotes.BLUR:
			return {
				...state,
				focused: false,
			}
		default:
			return state
	}
}

const contactID = (state = 'new', action) => {
	switch (action.type) {
		case ActionType.Contacts.RECEIVE_CONTACT:
			if (action.payload && action.payload.id) {
				return action.payload.id
			}
			return 'new'
		case ActionType.Inbox.SELECT_CONVERSATION:
			if (action.payload) return action.payload
			return state
		default:
			return state
	}
}

const groupID = (state = 'new', action) => {
	switch (action.type) {
		case ActionType.Contacts.RECEIVE_GROUP:
			if (action.payload && action.payload.id) {
				return action.payload.id
			}
			return 'new'
		default:
			return state
	}
}

const memberIDs = (state = [], action) => {
	switch (action.type) {
		case ActionType.Contacts.RECEIVE_GROUP:
			if (action.payload && action.payload.id) {
				return action.payload?.contact_ids
			}
			return []
		case ActionType.Contacts.ADD_CONTACTS_TO_GROUP_SUCCESS:
			return [...state, ...(action?.data?.contact_ids || [])]
		default:
			return state
	}
}

const groupDialogOpen = (state = false, action) => {
	if (action.type === ActionType.Contacts.TOGGLE_GROUP_DIALOG) {
		if (typeof action.payload === 'boolean') {
			return action.payload
		}
		return !state
	}
	return state
}

export default combineReducers({
	Entities: entitiesReducer,
	fields,
	addDetailsModalOpen,
	modal,
	smartNotes,
	contactID,
	groupSelect,
	groupID,
	memberIDs,
	groupDialogOpen,
})
